window.monitoringIconFormatter = function(value) {
    let html = '';
    switch (value) {
        case 'c sence':
            html += '<i class="fal fa-container-storage"></i>';
            break;
        case 'how':
            html += '<i class="fal fa-kitchen-set"></i>';
            break;
        case 'laravel horizon':
            html += '<i class="fab fa-laravel"></i>';
            break;
        case 'webserver':
            html += '<i class="fal fa-server"></i>';
            break;
    }
    return html;
};
